import { render, staticRenderFns } from "./ContainerKCPInformationDocumentsAddKcp.vue?vue&type=template&id=70aea7c0&"
import script from "./ContainerKCPInformationDocumentsAddKcp.vue?vue&type=script&lang=js&"
export * from "./ContainerKCPInformationDocumentsAddKcp.vue?vue&type=script&lang=js&"
import style0 from "./ContainerKCPInformationDocumentsAddKcp.vue?vue&type=style&index=0&id=70aea7c0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports